<template>
    <div class="finish-selection__wrapper">
        <div class="finish-selection__switch-toggle">
            <SwitchToggle :isSelected="isSynced" id="doorFitFinderToggle" labelAlignment="right" label="Sync finish across all hardware:" @onSwitchChange="handleSwitchChange" />
        </div>
        <div class="finish-selection__finish-list">
            <ul class="finish-grid-list">
                <li class="finish-grid-list__item" v-for="(finish, index) in finishes">
                    <FinishItem v-bind="finish" @update-selection="handleUpdateSelection"></FinishItem>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import SwitchToggle from './shared/SwitchToggle.vue';
import FinishItem from './shared/FinishItem.vue';
export default {
    name: 'FinishSelection',
    components: {
        SwitchToggle,
        FinishItem,
    },
    props: {
        syncedFinish: {
            type: String,
            default: '',
        },
        productFinish: {
            type: String,
            default: '',
        },
        finishes: {
            type: Array,
            default: [],
        },
    },
    computed: {
        isSynced() {
            return !!this.syncedFinish;
        },
        isFinishLoading() {
            return this.$store.state.isFinishLoading;
        },
    },
    emits: ['update-route', 'update-selection'],
    methods: {
        async handleSwitchChange(isSelected: boolean) {
                if (isSelected) {
                    await this.$emit('update-selection', { selection: this.productFinish, fieldId: 'selections.syncedFinish' });
                } else {
                    await this.$emit('update-selection', { selection: null, fieldId: 'selections.syncedFinish' });
                }

        },
        async handleUpdateSelection(finish: any) {
            if (this.isSynced) {
                let finishSelections = { ...finish };

                const display = JSON.parse(JSON.stringify(finishSelections));

                await this.$emit('update-selection', { ...display, syncedFinish: display.selection.displayName });
            } else {
                await this.$emit('update-selection', { ...finish });
            }
        },
    },
    mounted() {},
};
</script>
